import { VAlert } from 'vuetify/lib/components/VAlert';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isShow)?_c(VAlert,{class:(_vm.$vuetify.breakpoint.mobile) ? 'alert alert-mobile' : 'alert',attrs:{"dismissible":"","variant":"outlined"}},[_c('h5',{staticClass:"mb-0 text-center"},[_vm._v(" "+_vm._s(_vm.message)+" ")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }